import socket from './wsCommon';
import { getMessage, getFrameData, buildRequestDataToBytes } from '@/proto/helper.js';
import { useFrameDataStore } from "@/store/frameDataStore";
import { useHostConfigStore } from '@/store/hostConfigStore';
import { collectExtraInfoSample } from '@/utils/timeAlign';
let frameDataStore = null;
/**
 * 建立链接之后，发起消息，告知哪个车。
 * @returns 
 */
function onOpen(baseData) {
  setTimeout(() => {
    let map = new Map();
    map.set('play_pos', baseData.startTs + '');
    map.set('end_pos', baseData.endTs + '');
    map.set('vehicle', baseData.vehicleId + '');
    let bytes = buildRequestDataToBytes(
      '1002',
      '/live_mode/send_progress',
      map,
      0,
    );
    baseData.ws?.send(bytes);
  }, 100)
}
// 监听websocket消息信息
function onMessage(event, baseData) {
  let message = getMessage(event.data);
  const hasFrameData = !!message.hasFrameData();
  if (hasFrameData) {
    const dataList = getFrameData(message);
    dataList.forEach(frameData => {
      if (frameData.timestamp == 1) {
        //结束了
        console.log("download:",baseData.isfritst,baseData.startTs, baseData.endTs);
        baseData.callbackForOver(baseData.vehicleId, baseData.startTs, baseData.endTs)
        if (baseData.isfritst) {
          console.log('start play');          
          frameDataStore.startPlay();
        }
      } else {
        // //debug
        // if (frameData.vehicleData) {
        //    const loc = frameData.vehicleData.localization;
        //    if (loc === undefined) {
        //      console.warn(`[Debug] 'localization' is completely missing at timestamp: ${frameData.timestamp}`);
        //    } else if (loc.sourceFrom === undefined) {
        //      console.warn(`[Debug] 'localization' exists but 'sourceFrom' is undefined at timestamp: ${frameData.timestamp}`);
        //    } else if (loc.sourceFrom !== 1 && loc.sourceFrom !== 2 && loc.sourceFrom !== 3 && loc.sourceFrom !== 4) {
        //      console.warn(`[Debug] 'sourceFrom' has an unusual value: ${loc.sourceFrom} at timestamp: ${frameData.timestamp}`);
        //    }
        // }
        // console.log('frameData:', frameData);
        // console.log('extraInfo:', frameData.extraInfo);
        // 收集服务端透传的 serverTime/clientTime，供进度条旗子做时间补偿
        collectExtraInfoSample(frameData.extraInfo);
        frameDataStore.saveFrameData(frameData)
      }
    })
  }
  message = null;
}
// websocket连接关闭回调
function onClose(event) {
  console.log('ws closed:', event);
}
// websocket连接错误回调
function onError(err) {
  console.log('ws error:', err);
}

/**
 * 给现有的ws发送消息，根据时间区间获取响应数据。
 */
export function send_message_getFrameDataByTimeInterval(origin, vehicle, startTs, endTs, callbackForOver, isfritst = false) {
  let baseData = {
    ws: null,
    vehicleId: null,
    startTs: 0,
    endTs: 0
  };
  baseData.startTs = startTs
  baseData.endTs = endTs
  baseData.callbackForOver = callbackForOver
  baseData.vehicleId = vehicle
  baseData.origin = origin
  baseData.isfritst = isfritst
  frameDataStore = useFrameDataStore();
  let baseU = origin == "beijing1" ? useHostConfigStore().host_config.VITE_NODE_HOST_BJ : useHostConfigStore().host_config.VITE_NODE_HOST;
  baseData.ws = socket({
    baseUrl: baseU + "?" + vehicle,
    onMessage: (event) => {
      onMessage(event, baseData);
    },
    onOpen: () => {
      onOpen(baseData);
    },
    onError,
    onClose,
  });
  return baseData.ws
}
